<div class="true-modal-container">
    <div *ngIf="state=='list'">
        <h1>My assessments</h1>
    
        <ul>
            <li *ngFor="let assessment of assessments">
                <input name="assessmentId" type="radio" [value]="assessment.id" [id]="assessment.id" [(ngModel)]="assessmentId" />
                <label [for]="assessment.id">{{assessment.name | truncate: 25}}, {{assessment.createdAt | date: 'dd. MM. yyyy HH:mm'}}</label>
            </li>
        </ul>
    
        <div class="textual" *ngIf="!simple">
            <button (click)="create()" class="enabled">Create new assessment</button>
            <button (click)="importDemo()" class="enabled">Import demo assessment</button>
            <button (click)="load()" [ngClass]="{enabled: assessmentId !== null}">Load selected assessment</button>
            <button (click)="delete()" [ngClass]="{enabled: assessmentId !== null}">Delete selected assessment</button>
            <button (click)="edit()" [ngClass]="{enabled: assessmentId !== null}">Edit selected assessment</button>
        </div>
    
        <div *ngIf="simple" class="simple">
            <button class="cancel" (click)="close()"></button>
            <button (click)="load()" [ngClass]="{enabled: assessmentId !== null}"></button>
        </div>
    </div>
    
    <div *ngIf="state === 'create' || state === 'edit'">        
        <h1>{{ state === 'edit' ? 'Edit selected' : 'Create new' }} assessment</h1>        
      
        <!-- Name field -->
        <div class="form-row">
          <div class="form-col-label">
            <label for="name">Name:</label>
          </div>
          <div class="form-col-input">
            <input id="name" type="text" [(ngModel)]="name" />
          </div>            
        </div>
      
        <!-- Farm description field -->
        <div class="form-row">
          <div class="form-col-label">
            <label for="productInfo">Product or service description:</label>
          </div>
          <div class="form-col-input">
            <textarea id="productInfo"
                      rows="15"
                      [(ngModel)]="productInfo"
                      placeholder="Describe the product or service you are developing the business model for"></textarea>
          </div>
        </div>
      
        <!-- Type field -->
        <div class="form-row">
          <div class="form-col-label">
            <label for="objectId">Type:</label>
          </div>
          <div class="form-col-input">
            <fieldset id="objectId">
              <label *ngFor="let object of objects">
                <input type="radio" [(ngModel)]="objectId" [value]="object.id"/>{{object.name}}
              </label>
            </fieldset>
          </div>            
        </div>
      
        <!-- Action buttons -->
        <div class="simple">
          <button class="cancel" (click)="cancel()"></button>
          <button (click)="update()"></button>
        </div>
      </div>
      
    
</div>